import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useApi } from "../../api";
import { Notice } from "../../lib/ui";

/*
 * Add / edit account – port of account_form.php (API: /api/accounts, backend/ledger.py)
 * Routes: /account_form (add) and /account_form/:id (edit). Number, name and type are required.
 */

const BLANK = { account_number: "", account_name: "", account_type: "", status: "Active" };

export default function AccountForm() {
  const { id } = useParams();
  const editing = !!id;
  const api = useApi();
  const navigate = useNavigate();
  const [form, setForm] = useState(BLANK);
  const [notice, setNotice] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!editing) { setForm(BLANK); return; }
    api.get(`/api/accounts/${id}`).then((a) => setForm({ ...BLANK, ...a })).catch((e) => setNotice({ tone: "err", text: e.message }));
  }, [api, id, editing]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    setBusy(true); setNotice(null);
    try {
      const r = editing ? await api.request(`/api/accounts/${id}`, "PUT", form) : await api.post("/api/accounts", form);
      setNotice({ tone: "ok", text: r.message });
      if (!editing) setForm(BLANK);
    } catch (err) { setNotice({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };

  return (
    <main className="pg" style={{ maxWidth: "46rem" }}>
      <nav className="crumbs" aria-label="Breadcrumb"><Link to="/dashboard">Home</Link><i className="fas fa-chevron-right" /><span>Finance</span>
        <i className="fas fa-chevron-right" /><span aria-current="page">{editing ? "Edit account" : "Add account"}</span></nav>
      <div className="pg-head"><div className="pg-title"><span className="chip"><i className="fas fa-book text-indigo-500" /></span>
        <div><h1>{editing ? "Edit account" : "Add account"}</h1><p>Chart of accounts</p></div></div>
        {editing && <button type="button" className="btn" onClick={() => navigate("/account_form")}><i className="fas fa-plus" /> New account</button>}
      </div>
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <div className="panel">
        <form className="form" onSubmit={save} style={{ maxWidth: "none" }}>
          <div className="field"><label htmlFor="af-no">Account number<span className="req">*</span></label><input id="af-no" required value={form.account_number} onChange={set("account_number")} /></div>
          <div className="field"><label htmlFor="af-name">Account name<span className="req">*</span></label><input id="af-name" required value={form.account_name} onChange={set("account_name")} /></div>
          <div className="field"><label htmlFor="af-type">Account type<span className="req">*</span></label>
            <input id="af-type" required list="af-types" value={form.account_type} onChange={set("account_type")} />
            <datalist id="af-types">{["Asset", "Liability", "Equity", "Revenue", "Expense"].map((t) => <option key={t} value={t} />)}</datalist></div>
          <div className="field"><label htmlFor="af-st">Status</label>
            <select id="af-st" value={form.status} onChange={set("status")}><option>Active</option><option>Inactive</option></select></div>
          <div className="form-actions"><button type="submit" className="btn primary" disabled={busy}>{editing ? "Update account" : "Add account"}</button></div>
        </form>
      </div>
    </main>
  );
}
